module.exports = __webpack_public_path__ + "static/media/5.03965ecb.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/5.wav
// module id = 33
// module chunks = 0